<template>
  <!--<div id="app" ref="app">
    <el-container>
      <el-header height="0">
        <NavBar/>
        <MobileNavBar/>
      </el-header>
      <el-main style="padding: 0;">
        <SideTool/>
        <router-view />
      </el-main>
      <el-footer style="padding: 0;">
        <CallMe/>
        <MobileCallMe/>
      </el-footer>
    </el-container>
  </div>-->
  <component :is="layoutComponent">
    <router-view /> <!-- 当前路由对应的页面组件 -->
  </component>
</template>

<script>
  import NavBar from "@/components/nav-bar/index.vue"
  import MobileNavBar from "@/components/nav-bar/MobileNavBar.vue"
  import CallMe from "@/components/call-me/index.vue"
  import MobileCallMe from '@/components/call-me/MobileCallMe.vue'
  import SideTool from '@/components/SideTool.vue'
export default {
  name: 'App',
  components: { NavBar, MobileNavBar, CallMe, MobileCallMe, SideTool },
  computed: {
    layoutComponent() {
      // 默认为 DefaultLayout，若未设置 meta.layout 则回退
      const layout = this.$route.meta.layout || 'DefaultLayout';
      return () => import(`@/layouts/${layout}.vue`);
    }
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

// 全局滚动条样式
::-webkit-scrollbar {
  width: 4px; // 减小滚动条宽度
}

::-webkit-scrollbar-track {
  background: #f1f1f1; // 滚动条轨道颜色
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1; // 滚动条滑块颜色
  border-radius: 2px;
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; // 悬停时滚动条滑块颜色
}

// Firefox滚动条样式
html {
  scrollbar-width: thin; // 细滚动条
  scrollbar-color: #c1c1c1 #f1f1f1; // 滑块颜色 轨道颜色
}

@import url('./assets/css/icon.css');
</style>
